<template>
    <!-- Modal ACTION -->
    <modal v-if="actionModal" @close="actionModal = false">
        <template slot="header">
            <h4 class="modal-title">Ações para {{ editFieldsTitle }}</h4>
            <md-button
                class="md-simple md-just-icon md-round modal-default-button"
                @click="actionModal = false"
            >
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <div style="text-align: left">
                <!-- TODO pegar essas opções dinamicamente na rota -->
                <md-switch v-model="actionsSelectedModel" value="1">
                    Simulação de Novos Produtos
                </md-switch>
                <br />
                <md-switch v-model="actionsSelectedModel" value="2">
                    Simulação Diária
                </md-switch>
                <br />
                <md-switch v-model="actionsSelectedModel" value="3">
                    Ranqueamento
                </md-switch>
                <br />
                <md-switch v-model="actionsSelectedModel" value="4">
                    Reposição Dinâmica
                </md-switch>
            </div>
        </template>

        <template slot="footer">
            <md-button class="md-simple" @click="actionModal = false">
                Cancelar
            </md-button>
            <md-button
                class="md-primary"
                @click="actionModalSubmit()"
                :disabled="actionModalLoading"
            >
                <i class="fas fa-spinner fa-spin" v-if="actionModalLoading"></i>
                Confirmar
            </md-button>
        </template>
    </modal>
</template>

<script>
import { mapActions } from 'vuex'
import { Modal } from '@/components'

const AVAILABLE_ACTIONS = {
    1: true,
    2: true,
    3: true,
    4: true
}

export default {
    props: {
        baseStore: { type: String, required: true },
        parameterType: {
            type: String,
            required: true,
            validator: value =>
                ['branch', 'dc', 'branch-parameter'].indexOf(value) !== -1
        },
        parameters: {
            type: Array,
            required: true
        },
        simulation: {
            type: Object,
            default: null
        }
    },
    components: {
        Modal
    },
    created() {
        this.readParameters = function() {
            this.$store.dispatch.apply(null, [
                this.baseStore + '/read',
                ...arguments
            ])
        }
        this.updateParameters = function() {
            this.$store.dispatch.apply(null, [
                this.baseStore + '/update',
                ...arguments
            ])
        }
    },
    computed: {
        ...mapActions('simulations', {
            executeSimulation: 'execute'
        }),

        selectedRows() {
            return this.parameters.filter(
                a => this.selectedBranches.filter(b => a.branch == b).length > 0
            )
        },

        editFieldsTitle() {
            let aux = this.selectedRows

            if (!aux || aux.length < 1) return ''

            return aux
                .map(a => a.branch_name)
                .reduce((acc, current, i) =>
                    i < this.selectedRows.length - 1
                        ? acc + ', ' + current
                        : acc + ' e ' + current
                )
        }
    },
    data() {
        return {
            actionModal: false,
            actionModalLoading: false,

            selectedBranches: [],
            actionsSelectedModel: [],

            // dynamic methods
            readParameters: null,
            updateParameters: null
        }
    },
    methods: {
        // ACTIONS MODAL
        actionModalOpen(selectedBranches) {
            this.selectedBranches = selectedBranches

            // use object to perform idempotent actions (shallow copy)
            let availableActions = { ...AVAILABLE_ACTIONS } // TODO: fetch this from backend
            // for each branch parameter
            this.parameters.forEach(parameter => {
                // if it is selected
                if (this.selectedBranches.indexOf(parameter.branch) >= 0)
                    // check if it has all the actions
                    Object.keys(availableActions).forEach(actionId => {
                        // if not, disable it from the object
                        if (parameter.actions.indexOf(parseInt(actionId)) < 0)
                            availableActions[actionId] = false
                    })
            })
            this.actionsSelectedModel = []
            // add action ids if they are on for all the selected params
            Object.keys(availableActions).forEach(idx => {
                if (availableActions[idx]) this.actionsSelectedModel.push(idx)
            })

            this.actionModal = true
        },
        async actionModalSubmit() {
            // NOTE: we don't need a clone to edit actions
            if (this.selectedBranches.length < 1) return
            this.actionModalLoading = true

            let updateParams = {
                simulation: this.simulation.id,
                actions:
                    this.actionsSelectedModel.length > 0
                        ? this.actionsSelectedModel.reduce(
                              (acc, current) => acc + ',' + current
                          )
                        : 'null'
            }

            if (this.parameterType == 'branch')
                updateParams.branch_ids = this.selectedBranches.reduce(
                    (acc, current) => acc + ',' + current
                )
            else if (this.parameterType == 'dc')
                updateParams.dc_ids = this.selectedBranches.reduce(
                    (acc, current) => acc + ',' + current
                )

            await this.updateParameters(updateParams)

            await this.readParameters({
                simulation: this.simulation.id
            })

            this.actionModalLoading = false
            this.actionModal = false
        }
    }
}
</script>
